var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDobleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doble-check"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0795 14.6393L18.648 8.07082C19.0423 7.67642 19.0423 7.02366 18.648 6.62928C18.2536 6.2349 17.6008 6.2349 17.2064 6.62928L11.3588 12.477L10.5732 11.6916L9.13169 13.1331L10.638 14.6393C10.8284 14.8296 11.0868 14.9384 11.3588 14.9384C11.6307 14.9384 11.8891 14.8296 12.0795 14.6393Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68333 14.6425L13.2555 8.0715C13.6501 7.67695 13.6501 7.02393 13.2555 6.6294C12.8609 6.23486 12.2078 6.23486 11.8132 6.6294L5.96216 12.4794L3.39039 9.90812C2.99579 9.51359 2.34265 9.51359 1.94805 9.90812C1.55345 10.3027 1.55345 10.9557 1.94805 11.3502L5.24099 14.6425C5.43149 14.833 5.69002 14.9418 5.96216 14.9418C6.2343 14.9418 6.49284 14.833 6.68333 14.6425Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDobleCheck);
export default __webpack_public_path__ + "static/media/doble-check.d54da46701278e89c896864bc22cce08.svg";
export { ForwardRef as ReactComponent };